// extracted by mini-css-extract-plugin
export default {"Container":"Notifications_Container__3GZj-","wrapper":"Notifications_wrapper__5o6dV","right":"Notifications_right__8TozD","Notifications":"Notifications_Notifications__8ZX7D"};